import React from 'react';
import { OFFER_ANCHOR } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  'aria-label'?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  className = '',
  'aria-label': ariaLabel
}: CTAButtonProps) {
  return <a href={href} aria-label={ariaLabel} className={`inline-flex w-full items-center justify-center gap-2 rounded-lg border-b-4 border-black/30 bg-brand-yellow px-4 py-3 text-center font-cond text-[14px] font-bold uppercase leading-tight tracking-wide text-brand-carbon shadow-lg shadow-black/20 transition-[background-color,transform] duration-150 ease-out hover:bg-brand-gold active:translate-y-1 active:border-b-0 sm:text-base ${className}`} data-id="element-40" data-mp="2fzbtggqcdg4d">
      {children}
    </a>;
}